import { FC, useEffect, useState } from 'react';
import { useSearchBox } from 'react-instantsearch';
import { useArticlesPage, useForceFirstProductPage } from '../../shared/states/searchResultsPages';

export const SearchQuerySync: FC<{ searchQuery: string }> = ({ searchQuery }) => {
  const { refine } = useSearchBox();
  const [shouldRefine, setShouldRefine] = useState(false);

  const setArticlesPage = useArticlesPage((store) => store.setPage);
  const setForceFirstProductPage = useForceFirstProductPage((store) => store.setForce);

  useEffect(() => {
    if (shouldRefine) {
      setArticlesPage(1);
      setForceFirstProductPage(true);
      refine(searchQuery);
    } else {
      setShouldRefine(true);
    }
  }, [searchQuery, refine]);

  return null;
};
